import { TagEnum } from "../enums/tag.enum";
import { CtfStatusEnum } from "./ctf-status.enum";

export class GetCtfAction {
  static readonly type = "[CTF] Get Ctf";
}

export class FilterCtfAction {
  static readonly type = "[CTF] Filter Ctf";
  constructor(public payload: {
    selectTheme: TagEnum | "Tous";
    selectDifficulty: number | "Tous";
    selectStatus: CtfStatusEnum | "Tous";
  }) {}
}
